var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{staticClass:"load_title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }